export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'it', 'es', 'el', 'da', 'pt', 'cs', 'ca', 'nl', 'hu', 'hr', 'pl'] as const;

export const TRANSLATION_NAMESPACE = {
  ai_search: 'ai_search',
  chatbot: 'chatbot',
  common: 'common',
  favorites: 'favorites',
  listing_data: 'listing_data',
  lead_flows: 'lead-flows',
  not_found: 'not_found',
  private_office: 'private_office',
  property_card: 'property_card',
  property_expose: 'property_expose',
  search_module: 'search_module',
  sp_header_footer: 'sp_header_footer',
  user_account: 'user_account',
  watchlist: 'watchlist',
} as const;

export const TRANSLATION_NAMESPACES = Object.values(TRANSLATION_NAMESPACE);

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export type TranslationNamespace = (typeof TRANSLATION_NAMESPACE)[keyof typeof TRANSLATION_NAMESPACE];
